export function assignOwnProperties<T extends object>(target: T, data?: object | null) {
  // Immediately return if there's no data to assign.
  if (data === undefined || data === null) {
    return;
  }

  const properties = Object.getOwnPropertyNames(target);
  Object.keys(data).forEach((key) => {
    if (properties.includes(key)) {
      target[key as keyof typeof target] = data[key as keyof typeof data];
    }
  });
}
